import React from 'react';
import { oneOfType, string, number, element, arrayOf } from 'prop-types';
import styled from 'styled-components';


const Header = styled.td`
    vertical-align: top;
    background: rgba(0, 0, 0, 0.03);
    color: rgba(0,0,0,.6);
    padding: 0.75rem;
`;

const Value = styled.td`
    padding: 0.75rem;
    max-width: 700px;
`;


const Body = ({ children }) => (
    <table>
        <tbody>
            { children }
        </tbody>
    </table>
);

const Row = ({ header, children }) => (
    <tr>
        <Header>{ header }</Header>
        <Value>{ children }</Value>
    </tr>
);

Body.propTypes = {
    children: oneOfType([
        element,
        arrayOf(element),
    ]).isRequired,
};

Row.propTypes = {
    header: string.isRequired,
    children: oneOfType([string, number, element]),
};


export default { Body, Row };
